
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const ShipmentLegs = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        if(style.transit_delay==="#cccc" || style.transit_delay ==="#ffc107"){
            return;
        }
        
        props.onShowTransitData(props)
        setVisibleGroupID(null);
    };
    const style = {
        transit_delay: "#cccc",
        no_gps_data: "#cccc",
        enroute_exception: "#cccc",
        overspeeding_exception: "#cccc",
        nightdriving_exception: "#cccc",
        loading_delay_exception: "#cccc",
        unloading_delay_exception: "#cccc",
        consignment: "#cccc",
        upload_document: "#387ff2",
        view_document:"#cccc"
    }
    if (props?.data?.transit_delay != undefined && props?.data?.transit_delay == 1) {
        style["transit_delay"] = "#ffc107"
    }
    

    return (
        <div className="map-icon-component">
			{/*<button onClick={handleClick} className="custom-btn label label-success" title="View Timeline"><i className="icofont icofont-tree-alt"></i> Timeline </button>
            &nbsp;| &nbsp;
            */}
 {/* { props.hasUpload !==1 ? (
                <button onClick={handleRouteClick} className="custom-btn label label-success" title="Shipment Legs">
                    <i className="icofont icofont-site-map f20"></i> 
                </button>
            ): (<button onClick={handleRouteClick}  style={{border:"none", backgroundColor:"transparent",
                pointerEvents: props.disabled ? "none" : "auto", 
                opacity: props.disabled ? 0.5 : 1, }}className="custom-btn label label-success" title="Upload POD Inside">
<button className="icon-square" style={{color:"green"}}>
    <i className="icofont icofont-arrow-right" style={{color:"green"}}></i>
</button>        </button>)}        */}
 <span onClick={handleRouteClick} title="Transit Delay">
                        <i className="icofont icofont-clock-time f18" style={{ color: style.transit_delay }}></i>
                    </span>
        </div>
    );
};

export default ShipmentLegs;
